export default __webpack_public_path__ + "static/media/fantom.40755d1e.png";